export enum CheckInStatus {
  ReadyForCheckIn = "readyForCheckIn",
  CheckedIn = "checkedIn",
  ReadyForNonQRCheckIn = "readyForNonQRCheckIn",
  CheckInNotAvailable = "checkInNotAvailable",
  NotCheckedIn = "notCheckedIn",
}
